import React, { useState } from "react";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import MobileShell from "./components/MobileShell";
import BottomNav from "./components/BottomNav";
import AaryaMark from "./components/AaryaMark";
import Onboarding from "./screens/Onboarding";
import Home from "./screens/Home";
import Circle from "./screens/Circle";
import Activity from "./screens/Activity";
import Profile from "./screens/Profile";
import { InviteParentScreen, RadarScreen } from "./screens/SubScreens";
import InviteAccept from "./screens/InviteAccept";

// Detect the /i/{token} public invite route from the URL. This is a public
// landing page with NO auth required - a Trust-Circle invitee taps the SMS
// link and lands here regardless of login state.
function getInviteTokenFromUrl() {
  if (typeof window === "undefined") return null;
  const m = window.location.pathname.match(/^\/i\/([A-Za-z0-9_-]{8,})\/?$/);
  return m ? m[1] : null;
}

function Splash() {
  return (
    <div className="min-h-[60dvh] flex flex-col items-center justify-center px-8 text-center" data-testid="splash">
      <AaryaMark size={88}/>
      <p className="mt-4 font-display text-3xl text-ink-900 tracking-tight">Aarya</p>
      <p className="text-[12px] tracking-[0.18em] text-ink-500 uppercase mt-1">From the Heart, For Every Home</p>
      <img
        src="/indoblitz-logo.webp"
        alt="IndoBlitz"
        className="mt-10 h-6 w-auto opacity-60"
        loading="lazy"
        draggable="false"
      />
      <p className="text-[10px] text-ink-500 mt-1 tracking-wide">A gift from IndoBlitz</p>
    </div>
  );
}

function Inner() {
  const { user, bootChecked } = useAuth();
  const [tab, setTab] = useState("home");

  // Public invite route wins over everything else - even if the invitee is
  // logged in as someone else, they should see this landing page.
  const inviteToken = getInviteTokenFromUrl();
  if (inviteToken) return <InviteAccept token={inviteToken}/>;

  if (!bootChecked) return <MobileShell><Splash/></MobileShell>;
  if (!user) return <MobileShell><Onboarding/></MobileShell>;

  const isSub = tab === "invite" || tab === "radar";
  const navTab = isSub ? "profile" : tab;

  let screen = null;
  if (tab === "home") screen = <Home onJump={setTab}/>;
  else if (tab === "circle") screen = <Circle onJump={setTab}/>;
  else if (tab === "activity") screen = <Activity/>;
  else if (tab === "profile") screen = <Profile onJump={setTab}/>;
  else if (tab === "invite") screen = <InviteParentScreen onBack={() => setTab("circle")}/>;
  else if (tab === "radar") screen = <RadarScreen onBack={() => setTab("profile")}/>;

  return (
    <MobileShell bottom={<BottomNav active={navTab} onChange={setTab}/>}>
      {screen}
    </MobileShell>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Inner/>
    </AuthProvider>
  );
}
